import $ from 'jquery';
import GaTracking from '../../../core/components/ga-tracking';
const $elements = $('.js__track-scroll-event');
const thresholds = [15, 30, 45, 60, 75, 90, 100];
const fired = [];
export default class ScrollEventTracker {
    static init() {
        if (!$elements.length)
            return;
        const onChange = () => {
            const percent = this.getScrollPercent();
            thresholds.forEach(threshold => {
                if (percent >= threshold && !fired[threshold]) {
                    fired[threshold] = true;
                    this.pushScrollDataLayerEvent($elements, threshold);
                }
            });
        };
        onChange();
        $(window).on('scroll', onChange);
        $(window).on('resize', onChange);
    }
    static getScrollPercent() {
        const doc = document.documentElement;
        const body = document.body;
        const scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
        const viewport = window.innerHeight || doc.clientHeight;
        const fullHeight = body.scrollHeight;
        const maxScrollable = Math.max(fullHeight - viewport, 1);
        const percentage = Math.min(Math.max((scrollTop / maxScrollable) * 100, 0), 100);
        return Math.round(percentage);
    }
    static pushScrollDataLayerEvent($element, percent) {
        const datalayer = $element.data('data-layer');
        if (datalayer) {
            const payload = {
                ...datalayer,
                eventLabel: `${percent}%`,
            };
            GaTracking.pushDataLayer(payload);
        }
    }
}
